import { apiClient, ApiResponse } from './client';

export interface DealNFT {
  id: string;
  nft_token_id: string;
  name: string | null;
  thumbnail_url: string | null;
  media_url: string | null;
  rarity_rank: number | null;
  min_sell_price: number;
  estimated_value: number;
  valuation_confidence: string;
  collection_id: string;
  collection_name: string;
  total_supply: number;
  min_sell_destination: string | null;
  min_sell_offer_id: string | null;
  discount_amount: number;
  discount_percentage: number;
  value_low: number;
  value_high: number;
  collection_points?: number | null;
}

export interface DealsPagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface DealsData {
  deals: DealNFT[];
  pagination: DealsPagination;
}

export type DealsResponse = ApiResponse<DealsData>;

export type DealsSortBy = 'xrp' | 'percentage';

export async function getDeals(page: number = 1, limit: number = 50, sort: DealsSortBy = 'xrp'): Promise<DealsResponse> {
  return apiClient.get<DealsResponse>(`/deals?page=${page}&limit=${limit}&sort=${sort}`);
}
